import React, { ReactNode } from 'react';

import { FormComponent } from 'components';
import { useInfiniteScroll } from 'hooks';
import * as M from 'styles/mobile';
import { title as titleStyle } from './style';

interface Item {
  id: number;
  title: string;
}

interface Props {
  pageTitle: ReactNode;
  items: Item[];
  isLoading: boolean;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => unknown;
  onSelect: (id: number) => void;
  onSearch: (keyword?: string) => void;
  searchPlaceholder?: string;
  emptyText?: string;
}

function MobileTitleList({
  pageTitle,
  items,
  isLoading,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
  onSelect,
  onSearch,
  searchPlaceholder = '타이틀로 검색해주세요',
  emptyText = '목록이 없습니다',
}: Props) {
  const sentinelRef = useInfiniteScroll({
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  return (
    <>
      <div css={M.stickyTop}>
        {pageTitle}
        <FormComponent.Form
          submit={({ keyword }: { keyword?: string }) =>
            onSearch(keyword?.trim() || undefined)
          }
        >
          <FormComponent.SearchInput
            name="keyword"
            placeholder={searchPlaceholder}
          />
        </FormComponent.Form>
      </div>
      <div css={M.list}>
        {items.map(({ id, title }) => (
          <button
            key={id}
            type="button"
            css={M.listItem}
            onClick={() => onSelect(id)}
          >
            <p css={titleStyle}>{title}</p>
          </button>
        ))}
        {!isLoading && items.length === 0 && <p css={M.empty}>{emptyText}</p>}
        {isFetchingNextPage && <p css={M.empty}>불러오는 중...</p>}
      </div>
      <div ref={sentinelRef} css={M.sentinel} />
    </>
  );
}

export default MobileTitleList;
